import { render, staticRenderFns } from "./withdraw-apply.vue?vue&type=template&id=139d05d0&scoped=true"
import script from "./withdraw-apply.vue?vue&type=script&lang=js"
export * from "./withdraw-apply.vue?vue&type=script&lang=js"
import style0 from "./withdraw-apply.vue?vue&type=style&index=0&id=139d05d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d05d0",
  null
  
)

export default component.exports